import {
  POS_LOGIN,
  POS_LOGOUT,
  POS_SET_ACTIVE_STORE,
  POS_LOGIN_ERROR,
} from "./actionTypes";

// Kept intentionally separate from the customer `user` slice.
// Shape: pos_user.user = { success, data, fetched }
const initialState = {
  user: {
    success: false,
    data: null,
    fetched: false,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_LOGIN:
      return {
        ...state,
        user: {
          success: !!action.payload.success,
          data: action.payload.data,
          fetched: true,
        },
        error: null,
      };

    case POS_SET_ACTIVE_STORE:
      if (!state.user.data) return state;
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            active_store_id: action.payload.store_id,
            modules: action.payload.modules || state.user.data.modules,
          },
        },
      };

    case POS_LOGIN_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case POS_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
